import type { CSSProperties } from 'react';
import { resolveUnitBaseColor, unitCardHighlightColors } from './getColorByUnit';

export interface UnitHeaderChrome {
  className: string;
  style?: CSSProperties;
}

// Focused unit: the periwinkle border of the AnimatedFocusPill over an off-white card.
const FOCUSED_CHROME = 'tw-bg-[#FEFBF9] tw-border-[#7D91FD]';
// Default: white card with the neutral-100 border every non-highlighted dashboard card uses.
const DEFAULT_CHROME = 'tw-bg-white tw-border-[#F1F0EE]';

/**
 * Resolves the border + background of the dashboard unit header card.
 *
 * A unit with every Target skill complete is tinted with its own colors, reusing the highlight palette
 * of the passed/inferred skill cards (`unitCardHighlightColors`): the unit's `-300` shade as the border
 * over its lighter `-100` shade as the background. Those are hex values (no Tailwind token), so they
 * come back as an inline style; the other states are plain classes. Completed wins over focused —
 * focus is still conveyed by the AnimatedFocusPill on top of the card.
 */
export const getUnitHeaderChrome = (
  unitName: string | undefined,
  { completed, focused }: { completed: boolean; focused: boolean },
): UnitHeaderChrome => {
  if (completed) {
    const { border, background } = unitCardHighlightColors[resolveUnitBaseColor(unitName)];
    return { className: '', style: { borderColor: border, backgroundColor: background } };
  }

  return { className: focused ? FOCUSED_CHROME : DEFAULT_CHROME };
};
